jQuery(document).foundation();

/*!
 * parallax.js v1.5.0 (http://pixelcog.github.io/parallax.js/)
 * @copyright 2016 PixelCog, Inc.
 * @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
 */
!function(t,i,e,s){function o(i,e){var h=this;"object"==typeof e&&(delete e.refresh,delete e.render,t.extend(this,e)),this.$element=t(i),!this.imageSrc&&this.$element.is("img")&&(this.imageSrc=this.$element.attr("src"));var r=(this.position+"").toLowerCase().match(/\S+/g)||[];if(r.length<1&&r.push("center"),1==r.length&&r.push(r[0]),"top"!=r[0]&&"bottom"!=r[0]&&"left"!=r[1]&&"right"!=r[1]||(r=[r[1],r[0]]),this.positionX!==s&&(r[0]=this.positionX.toLowerCase()),this.positionY!==s&&(r[1]=this.positionY.toLowerCase()),h.positionX=r[0],h.positionY=r[1],"left"!=this.positionX&&"right"!=this.positionX&&(isNaN(parseInt(this.positionX))?this.positionX="center":this.positionX=parseInt(this.positionX)),"top"!=this.positionY&&"bottom"!=this.positionY&&(isNaN(parseInt(this.positionY))?this.positionY="center":this.positionY=parseInt(this.positionY)),this.position=this.positionX+(isNaN(this.positionX)?"":"px")+" "+this.positionY+(isNaN(this.positionY)?"":"px"),navigator.userAgent.match(/(iPod|iPhone|iPad)/))return this.imageSrc&&this.iosFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;if(navigator.userAgent.match(/(Android)/))return this.imageSrc&&this.androidFix&&!this.$element.is("img")&&this.$element.css({backgroundImage:"url("+this.imageSrc+")",backgroundSize:"cover",backgroundPosition:this.position}),this;this.$mirror=t("<div />").prependTo(this.mirrorContainer);var a=this.$element.find(">.parallax-slider"),n=!1;0==a.length?this.$slider=t("<img />").prependTo(this.$mirror):(this.$slider=a.prependTo(this.$mirror),n=!0),this.$mirror.addClass("parallax-mirror").css({visibility:"hidden",zIndex:this.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}),this.$slider.addClass("parallax-slider").one("load",function(){h.naturalHeight&&h.naturalWidth||(h.naturalHeight=this.naturalHeight||this.height||1,h.naturalWidth=this.naturalWidth||this.width||1),h.aspectRatio=h.naturalWidth/h.naturalHeight,o.isSetup||o.setup(),o.sliders.push(h),o.isFresh=!1,o.requestRender()}),n||(this.$slider[0].src=this.imageSrc),(this.naturalHeight&&this.naturalWidth||this.$slider[0].complete||a.length>0)&&this.$slider.trigger("load")}!function(){for(var t=0,e=["ms","moz","webkit","o"],s=0;s<e.length&&!i.requestAnimationFrame;++s)i.requestAnimationFrame=i[e[s]+"RequestAnimationFrame"],i.cancelAnimationFrame=i[e[s]+"CancelAnimationFrame"]||i[e[s]+"CancelRequestAnimationFrame"];i.requestAnimationFrame||(i.requestAnimationFrame=function(e){var s=(new Date).getTime(),o=Math.max(0,16-(s-t)),h=i.setTimeout(function(){e(s+o)},o);return t=s+o,h}),i.cancelAnimationFrame||(i.cancelAnimationFrame=function(t){clearTimeout(t)})}(),t.extend(o.prototype,{speed:.2,bleed:0,zIndex:-100,iosFix:!0,androidFix:!0,position:"center",overScrollFix:!1,mirrorContainer:"body",refresh:function(){this.boxWidth=this.$element.outerWidth(),this.boxHeight=this.$element.outerHeight()+2*this.bleed,this.boxOffsetTop=this.$element.offset().top-this.bleed,this.boxOffsetLeft=this.$element.offset().left,this.boxOffsetBottom=this.boxOffsetTop+this.boxHeight;var t,i=o.winHeight,e=o.docHeight,s=Math.min(this.boxOffsetTop,e-i),h=Math.max(this.boxOffsetTop+this.boxHeight-i,0),r=this.boxHeight+(s-h)*(1-this.speed)|0,a=(this.boxOffsetTop-s)*(1-this.speed)|0;r*this.aspectRatio>=this.boxWidth?(this.imageWidth=r*this.aspectRatio|0,this.imageHeight=r,this.offsetBaseTop=a,t=this.imageWidth-this.boxWidth,"left"==this.positionX?this.offsetLeft=0:"right"==this.positionX?this.offsetLeft=-t:isNaN(this.positionX)?this.offsetLeft=-t/2|0:this.offsetLeft=Math.max(this.positionX,-t)):(this.imageWidth=this.boxWidth,this.imageHeight=this.boxWidth/this.aspectRatio|0,this.offsetLeft=0,t=this.imageHeight-r,"top"==this.positionY?this.offsetBaseTop=a:"bottom"==this.positionY?this.offsetBaseTop=a-t:isNaN(this.positionY)?this.offsetBaseTop=a-t/2|0:this.offsetBaseTop=a+Math.max(this.positionY,-t))},render:function(){var t=o.scrollTop,i=o.scrollLeft,e=this.overScrollFix?o.overScroll:0,s=t+o.winHeight;this.boxOffsetBottom>t&&this.boxOffsetTop<=s?(this.visibility="visible",this.mirrorTop=this.boxOffsetTop-t,this.mirrorLeft=this.boxOffsetLeft-i,this.offsetTop=this.offsetBaseTop-this.mirrorTop*(1-this.speed)):this.visibility="hidden",this.$mirror.css({transform:"translate3d("+this.mirrorLeft+"px, "+(this.mirrorTop-e)+"px, 0px)",visibility:this.visibility,height:this.boxHeight,width:this.boxWidth}),this.$slider.css({transform:"translate3d("+this.offsetLeft+"px, "+this.offsetTop+"px, 0px)",position:"absolute",height:this.imageHeight,width:this.imageWidth,maxWidth:"none"})}}),t.extend(o,{scrollTop:0,scrollLeft:0,winHeight:0,winWidth:0,docHeight:1<<30,docWidth:1<<30,sliders:[],isReady:!1,isFresh:!1,isBusy:!1,setup:function(){function s(){if(p==i.pageYOffset)return i.requestAnimationFrame(s),!1;p=i.pageYOffset,h.render(),i.requestAnimationFrame(s)}if(!this.isReady){var h=this,r=t(e),a=t(i),n=function(){o.winHeight=a.height(),o.winWidth=a.width(),o.docHeight=r.height(),o.docWidth=r.width()},l=function(){var t=a.scrollTop(),i=o.docHeight-o.winHeight,e=o.docWidth-o.winWidth;o.scrollTop=Math.max(0,Math.min(i,t)),o.scrollLeft=Math.max(0,Math.min(e,a.scrollLeft())),o.overScroll=Math.max(t-i,Math.min(t,0))};a.on("resize.px.parallax load.px.parallax",function(){n(),h.refresh(),o.isFresh=!1,o.requestRender()}).on("scroll.px.parallax load.px.parallax",function(){l(),o.requestRender()}),n(),l(),this.isReady=!0;var p=-1;s()}},configure:function(i){"object"==typeof i&&(delete i.refresh,delete i.render,t.extend(this.prototype,i))},refresh:function(){t.each(this.sliders,function(){this.refresh()}),this.isFresh=!0},render:function(){this.isFresh||this.refresh(),t.each(this.sliders,function(){this.render()})},requestRender:function(){var t=this;t.render(),t.isBusy=!1},destroy:function(e){var s,h=t(e).data("px.parallax");for(h.$mirror.remove(),s=0;s<this.sliders.length;s+=1)this.sliders[s]==h&&this.sliders.splice(s,1);t(e).data("px.parallax",!1),0===this.sliders.length&&(t(i).off("scroll.px.parallax resize.px.parallax load.px.parallax"),this.isReady=!1,o.isSetup=!1)}});var h=t.fn.parallax;t.fn.parallax=function(s){return this.each(function(){var h=t(this),r="object"==typeof s&&s;this==i||this==e||h.is("body")?o.configure(r):h.data("px.parallax")?"object"==typeof s&&t.extend(h.data("px.parallax"),r):(r=t.extend({},h.data(),r),h.data("px.parallax",new o(this,r))),"string"==typeof s&&("destroy"==s?o.destroy(this):o[s]())})},t.fn.parallax.Constructor=o,t.fn.parallax.noConflict=function(){return t.fn.parallax=h,this},t(function(){t('[data-parallax="scroll"]').parallax()})}(jQuery,window,document);

jQuery('a[href*="#"].arrowtag, a.anchor-btn')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
       jQuery('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = jQuery(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  // easing min.js

  (function(factory){if(typeof define==="function"&&define.amd){define(["jquery"],function($){return factory($)})}else if(typeof module==="object"&&typeof module.exports==="object"){exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.easing.jswing=$.easing.swing;var pow=Math.pow,sqrt=Math.sqrt,sin=Math.sin,cos=Math.cos,PI=Math.PI,c1=1.70158,c2=c1*1.525,c3=c1+1,c4=2*PI/3,c5=2*PI/4.5;function bounceOut(x){var n1=7.5625,d1=2.75;if(x<1/d1){return n1*x*x}else if(x<2/d1){return n1*(x-=1.5/d1)*x+.75}else if(x<2.5/d1){return n1*(x-=2.25/d1)*x+.9375}else{return n1*(x-=2.625/d1)*x+.984375}}$.extend($.easing,{def:"easeOutQuad",swing:function(x){return $.easing[$.easing.def](x)},easeInQuad:function(x){return x*x},easeOutQuad:function(x){return 1-(1-x)*(1-x)},easeInOutQuad:function(x){return x<.5?2*x*x:1-pow(-2*x+2,2)/2},easeInCubic:function(x){return x*x*x},easeOutCubic:function(x){return 1-pow(1-x,3)},easeInOutCubic:function(x){return x<.5?4*x*x*x:1-pow(-2*x+2,3)/2},easeInQuart:function(x){return x*x*x*x},easeOutQuart:function(x){return 1-pow(1-x,4)},easeInOutQuart:function(x){return x<.5?8*x*x*x*x:1-pow(-2*x+2,4)/2},easeInQuint:function(x){return x*x*x*x*x},easeOutQuint:function(x){return 1-pow(1-x,5)},easeInOutQuint:function(x){return x<.5?16*x*x*x*x*x:1-pow(-2*x+2,5)/2},easeInSine:function(x){return 1-cos(x*PI/2)},easeOutSine:function(x){return sin(x*PI/2)},easeInOutSine:function(x){return-(cos(PI*x)-1)/2},easeInExpo:function(x){return x===0?0:pow(2,10*x-10)},easeOutExpo:function(x){return x===1?1:1-pow(2,-10*x)},easeInOutExpo:function(x){return x===0?0:x===1?1:x<.5?pow(2,20*x-10)/2:(2-pow(2,-20*x+10))/2},easeInCirc:function(x){return 1-sqrt(1-pow(x,2))},easeOutCirc:function(x){return sqrt(1-pow(x-1,2))},easeInOutCirc:function(x){return x<.5?(1-sqrt(1-pow(2*x,2)))/2:(sqrt(1-pow(-2*x+2,2))+1)/2},easeInElastic:function(x){return x===0?0:x===1?1:-pow(2,10*x-10)*sin((x*10-10.75)*c4)},easeOutElastic:function(x){return x===0?0:x===1?1:pow(2,-10*x)*sin((x*10-.75)*c4)+1},easeInOutElastic:function(x){return x===0?0:x===1?1:x<.5?-(pow(2,20*x-10)*sin((20*x-11.125)*c5))/2:pow(2,-20*x+10)*sin((20*x-11.125)*c5)/2+1},easeInBack:function(x){return c3*x*x*x-c1*x*x},easeOutBack:function(x){return 1+c3*pow(x-1,3)+c1*pow(x-1,2)},easeInOutBack:function(x){return x<.5?pow(2*x,2)*((c2+1)*2*x-c2)/2:(pow(2*x-2,2)*((c2+1)*(x*2-2)+c2)+2)/2},easeInBounce:function(x){return 1-bounceOut(1-x)},easeOutBounce:bounceOut,easeInOutBounce:function(x){return x<.5?(1-bounceOut(1-2*x))/2:(1+bounceOut(2*x-1))/2}})});

  !function(){function e(){var e=!1;e&&c("keydown",o),g.keyboardSupport&&!e&&u("keydown",o)}function t(){if(document.body){var t=document.body,r=document.documentElement,a=window.innerHeight,o=t.scrollHeight;if(x=document.compatMode.indexOf("CSS")>=0?r:t,w=t,e(),S=!0,top!=self)y=!0;else if(o>a&&(t.offsetHeight<=a||r.offsetHeight<=a)&&(r.style.height="auto",x.offsetHeight<=a)){var n=document.createElement("div");n.style.clear="both",t.appendChild(n)}g.fixedBackground||b||(t.style.backgroundAttachment="scroll",r.style.backgroundAttachment="scroll")}}function r(e,t,r,a){if(a||(a=1e3),d(t,r),1!=g.accelerationMax){var o=+new Date,n=o-T;if(n<g.accelerationDelta){var i=(1+30/n)/2;i>1&&(i=Math.min(i,g.accelerationMax),t*=i,r*=i)}T=+new Date}if(M.push({x:t,y:r,lastX:0>t?.99:-.99,lastY:0>r?.99:-.99,start:+new Date}),!C){var l=e===document.body,u=function(){for(var o=+new Date,n=0,i=0,c=0;c<M.length;c++){var s=M[c],d=o-s.start,f=d>=g.animationTime,p=f?1:d/g.animationTime;g.pulseAlgorithm&&(p=h(p));var m=s.x*p-s.lastX>>0,w=s.y*p-s.lastY>>0;n+=m,i+=w,s.lastX+=m,s.lastY+=w,f&&(M.splice(c,1),c--)}l?window.scrollBy(n,i):(n&&(e.scrollLeft+=n),i&&(e.scrollTop+=i)),t||r||(M=[]),M.length?E(u,e,a/g.frameRate+1):C=!1};E(u,e,0),C=!0}}function a(e){S||t();var a=e.target,o=l(a);if(!o||e.defaultPrevented||s(w,"embed")||s(a,"embed")&&/\.pdf/i.test(a.src))return!0;var n=e.wheelDeltaX||0,i=e.wheelDeltaY||0;return n||i||(i=e.wheelDelta||0),!g.touchpadSupport&&f(i)?!0:(Math.abs(n)>1.2&&(n*=g.stepSize/120),Math.abs(i)>1.2&&(i*=g.stepSize/120),r(o,-n,-i),void e.preventDefault())}function o(e){var t=e.target,a=e.ctrlKey||e.altKey||e.metaKey||e.shiftKey&&e.keyCode!==H.spacebar;if(/input|textarea|select|embed/i.test(t.nodeName)||t.isContentEditable||e.defaultPrevented||a)return!0;if(s(t,"button")&&e.keyCode===H.spacebar)return!0;var o,n=0,i=0,u=l(w),c=u.clientHeight;switch(u==document.body&&(c=window.innerHeight),e.keyCode){case H.up:i=-g.arrowScroll;break;case H.down:i=g.arrowScroll;break;case H.spacebar:o=e.shiftKey?1:-1,i=-o*c*.9;break;case H.pageup:i=.9*-c;break;case H.pagedown:i=.9*c;break;case H.home:i=-u.scrollTop;break;case H.end:var d=u.scrollHeight-u.scrollTop-c;i=d>0?d+10:0;break;case H.left:n=-g.arrowScroll;break;case H.right:n=g.arrowScroll;break;default:return!0}r(u,n,i),e.preventDefault()}function n(e){w=e.target}function i(e,t){for(var r=e.length;r--;)z[N(e[r])]=t;return t}function l(e){var t=[],r=x.scrollHeight;do{var a=z[N(e)];if(a)return i(t,a);if(t.push(e),r===e.scrollHeight){if(!y||x.clientHeight+10<r)return i(t,document.body)}else if(e.clientHeight+10<e.scrollHeight&&(overflow=getComputedStyle(e,"").getPropertyValue("overflow-y"),"scroll"===overflow||"auto"===overflow))return i(t,e)}while(e=e.parentNode)}function u(e,t,r){window.addEventListener(e,t,r||!1)}function c(e,t,r){window.removeEventListener(e,t,r||!1)}function s(e,t){return(e.nodeName||"").toLowerCase()===t.toLowerCase()}function d(e,t){e=e>0?1:-1,t=t>0?1:-1,(k.x!==e||k.y!==t)&&(k.x=e,k.y=t,M=[],T=0)}function f(e){if(e){e=Math.abs(e),D.push(e),D.shift(),clearTimeout(A);var t=D[0]==D[1]&&D[1]==D[2],r=p(D[0],120)&&p(D[1],120)&&p(D[2],120);return!(t||r)}}function p(e,t){return Math.floor(e/t)==e/t}function m(e){var t,r,a;return e*=g.pulseScale,1>e?t=e-(1-Math.exp(-e)):(r=Math.exp(-1),e-=1,a=1-Math.exp(-e),t=r+a*(1-r)),t*g.pulseNormalize}function h(e){return e>=1?1:0>=e?0:(1==g.pulseNormalize&&(g.pulseNormalize/=m(1)),m(e))}var w,v={frameRate:150,animationTime:1800,stepSize:85,pulseAlgorithm:!0,pulseScale:8,pulseNormalize:1,accelerationDelta:20,accelerationMax:1,keyboardSupport:!0,arrowScroll:50,touchpadSupport:!0,fixedBackground:!0,excluded:""},g=v,b=!1,y=!1,k={x:0,y:0},S=!1,x=document.documentElement,D=[120,120,120],H={left:37,up:38,right:39,down:40,spacebar:32,pageup:33,pagedown:34,end:35,home:36},g=v,M=[],C=!1,T=+new Date,z={};setInterval(function(){z={}},1e4);var A,N=function(){var e=0;return function(t){return t.uniqueID||(t.uniqueID=e++)}}(),E=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||function(e,t,r){window.setTimeout(e,r||1e3/60)}}(),K=/chrome/i.test(window.navigator.userAgent),L="onmousewheel"in document;L&&K&&(u("mousedown",n),u("mousewheel",a),u("load",t))}();

//content Display animation

  const actionElements = document.querySelectorAll('.actioner');

  function entersView() {
      actionElements.forEach(function(actionElement) {
          
          const elementHeight = actionElement.offsetHeight;
          const elementBottom = (actionElement.getBoundingClientRect().top + window.pageYOffset) + elementHeight;
          const slideInAt = elementBottom - (elementHeight / (actionElement.dataset.enters || 2));
          const scrolledY = window.pageYOffset + window.innerHeight;
          
          const isHalfShown = scrolledY > slideInAt;
          const isNotScrolledPast = true; // FIX THIS WHEN NEEDED
              
          if (isHalfShown && isNotScrolledPast) {
              actionElement.classList.add('entered');
              } 
          else {
              actionElement.classList.remove('entered');
              }
          
  //        console.log({slideInAt, elementBottom, isHalfShown, isNotScrolledPast, scrolledY});
       });
      }


window.addEventListener('load', entersView); 
window.addEventListener('scroll', entersView); 



// PRIMARY MENU
const primaryLinks = document.querySelectorAll('.primary-menu a');
const megaSubMenu = document.querySelectorAll('.mega-sub-menu');
const hoverElements = document.querySelectorAll('.hoverer');
const hoverTargets = document.querySelectorAll('.hover-target');


function openSubMenu(rar) {
    const siteHeader = document.querySelector('.site-header');
    if(rar.type === 'mouseenter') {
        rar = rar.target;
       //console.log(rar);
        }
    
    // get link split up into an array
    const target = rar.href.split('/');
    console.log(target);
    // get the second until last value
    const targetClass = '.' + target[target.length - 2];
    console.log(targetClass);

    // remove previously active sub-nav
    if(settings.activeSub.target && settings.activeSub.target != targetClass) {
        document.querySelector('html').classList.remove('mega-nav-open');
        siteHeader.querySelector(settings.activeSub.target).classList.remove('active-delay');
        siteHeader.querySelector(settings.activeSub.target).classList.remove('active');
        settings.activeSub.li.classList.remove('active-hover');
        }   
    
    //if the sub-menu exists...
    if(siteHeader.querySelector(targetClass) != null) {
        document.querySelector('html').classList.add('mega-nav-open');
        settings.activeSub.target = targetClass;
        settings.activeSub.li = rar.parentNode;
        
        setTimeout(function() {
            siteHeader.querySelector(targetClass).classList.add('active-delay');
            }, 30);
        
        siteHeader.querySelector(targetClass).classList.add('active');
        settings.activeSub.li.classList.add('active-hover');
        }
        
    siteHeader.querySelector('.mega-nav-height-drop-down').style.height = siteHeader.querySelector(targetClass) ? siteHeader.querySelector(targetClass).offsetHeight + 'px' : settings.navHeight + 'px';
            
    }

function closeSubMenu() {
    const siteHeader = document.querySelector('.site-header');
    document.querySelector('html').classList.remove('mega-nav-open');
    
    siteHeader.querySelector('.mega-nav-height-drop-down').style.height = settings.navHeight + 'px';
    if(settings.activeSub.target) {        
        siteHeader.querySelector(settings.activeSub.target).classList.remove('active-delay');
        siteHeader.querySelector(settings.activeSub.target).classList.remove('active');
        settings.activeSub.li.classList.remove('active-hover');
        }
    } 


function navUpDown() {
    const scrollPosition = window.pageYOffset;
    const currentSiteHeaderHeight = document.querySelector('.site-header').offsetHeight;    
        
    if(scrollPosition >= document.querySelector('.entry-header').offsetHeight) {
        settings.navHeight = currentSiteHeaderHeight;
        document.querySelector('html').classList.add('past-entry-header');
        }
    
    else {
        settings.navHeight = navHeightConst;
        document.querySelector('html').classList.remove('past-entry-header');
        }
    
    if(scrollPosition > settings.scrollPosition && scrollPosition !== 0) {
        document.querySelector('html').classList.remove('nav-down');
        document.querySelector('html').classList.add('nav-up');
        // if you scroll with the nav open it doesn't hide the drop-down
        if(!document.querySelector('html').classList.contains('mega-nav-open')) {
            document.querySelector('.mega-nav-height-drop-down').style.height = currentSiteHeaderHeight + 'px';        
            }
        }
    else {
        document.querySelector('html').classList.remove('nav-up');
        document.querySelector('html').classList.add('nav-down');
        // if you scroll with the nav open it doesn't hide the drop-down
        if(!document.querySelector('html').classList.contains('mega-nav-open')) {
            document.querySelector('.mega-nav-height-drop-down').style.height = settings.navHeight + 'px';        
            }        
        }
    settings.scrollPosition = scrollPosition;
    }


function onHover() {
//    console.log(this.dataset.target);
    const $this = this;
    document.querySelector($this.dataset.target).classList.add('active');
    }

function offHover() {
    this.classList.remove('active');
    }


    (function eventListeners() {
        
        //IE 11 -- DIDN'T LIKE FOREACH - MIGHT DO INSIDE A FUNCTION? 27TH APRIL 2017
        for(var i = 0; i < primaryLinks.length; i++) {
            primaryLinks[i].addEventListener('mouseenter', openSubMenu);
            }

        for(var i = 0; i < megaSubMenu.length; i++) {
            megaSubMenu[i].addEventListener('mouseleave', closeSubMenu);
            }

        for(var i = 0; i < hoverElements.length; i++) {
            hoverElements[i].addEventListener('mouseenter', onHover);
            }

        for(var i = 0; i < hoverTargets.length; i++) {
            hoverTargets[i].addEventListener('mouseleave', offHover);
            }

        window.addEventListener('click', function(e) {
            try {            
                findParent(e.target, 'site-header');
                }
            catch(e) {
                closeSubMenu();
                }
             });
        
        
        })();


jQuery( "#open_menu, #close_menu" ).on( "click", function(e) {
   jQuery('.mobile_menu--reveal').toggleClass( "active" );
});

// calculator

// prevent default action of form

jQuery("#homecalc").submit(function(e){
    return false;
});

jQuery('#clear').click(function(){
  jQuery('#result span').html('0');
  jQuery('.form-error').fadeOut(300);
})

function checnum(as)
{
  var dd = as.value;
  if(isNaN(dd))
  {
    dd = dd.substring(0,(dd.length-1));
    as.value = dd;
  }   
}

function loan()
{
  var a = document.loanCalc.amt.value;
  var b = document.loanCalc.interest.value;
  var c = document.loanCalc.term.value;
  if(a.length === 0 || b.length === 0 || c.length === 0) {
    jQuery('.form-error').fadeIn(300);
      return false;
  }
  else {

  jQuery('.form-error').fadeOut(300);
  var n = c * 12;
  var r = b/(12*100);
  var p = (a * r *Math.pow((1+r),n))/(Math.pow((1+r),n)-1);
  var prin = Math.round(p*100)/100;
  prin = Math.round(prin);

  // document.loanCalc.r1.value = prin;
  console.log(prin);
  jQuery('#result span').html(prin);
  var mon = Math.round(((n * prin) - a)*100)/100;
  //console.log(mon);
  //document.first.r2.value = mon;
  var tot = Math.round((mon/n)*100)/100;
  //document.loanCalc.r3.value = tot;
  //console.log(tot);
  for(var i=0;i<n;i++)
  {
    var z = a * r * 1;
    var q = Math.round(z*100)/100;
    var t = p - z;
    var w = Math.round(t*100)/100;
    var e = a-t;
    var l = Math.round(e*100)/100;
    a=e;
  }
  }
}

const heightCon = document.querySelectorAll('.equal-height .text-content');
const adaptheight = document.querySelectorAll('.equal-height1 .text-content');


function getheight() {
  var heightval = jQuery(heightCon).outerHeight();
  console.log(heightval);
  jQuery(adaptheight).css("height", heightval);
}

window.addEventListener('load', getheight); 
window.addEventListener('resize', getheight); 


jQuery('#play-video').on('click', function(ev) {
    jQuery(this).hide();
    jQuery("#video")[0].src += "?rel=0&autoplay=1";
});

function getpietitle() {
const pietitle = document.querySelectorAll('.channelevents .title');
pielength = pietitle.length;
console.log(pielength);
for(var j=1 ;j<=pielength;j++) {
  jQuery(pietitle[j]).hide();
}
}

window.addEventListener('load', getpietitle); 

var quicklink_ui_data = {"z_index":"1"};

// quicklink UI jQuery
function quickpanel() {

    // Animation Slide
    var quicklink_panel = $('#quicklink-container'),
        quicklink_panel_w = quicklink_panel.width(),
        sbb_display_margin = 50;

    quicklink_panel.css('z-index', quicklink_ui_data.z_index);

    if (quicklink_panel.hasClass('quicklink-btns-left') && (quicklink_panel.hasClass('quicklink-anim-slide') || quicklink_panel.hasClass('quicklink-anim-icons'))) {

        quicklink_panel.css('left', '-' + (quicklink_panel_w - sbb_display_margin) + 'px');

    } else if (quicklink_panel.hasClass('quicklink-btns-right') && (quicklink_panel.hasClass('quicklink-anim-slide') || quicklink_panel.hasClass('quicklink-anim-icons'))) {

        quicklink_panel.css('right', '-' + (quicklink_panel_w - sbb_display_margin) + 'px');

    }

    // Slide when hover
    quicklink_panel.hover(function () {

        if (quicklink_panel.hasClass('quicklink-btns-left') && quicklink_panel.hasClass('quicklink-anim-slide')) {

            quicklink_panel.stop().animate({'left': 0}, 300);

        } else if (quicklink_panel.hasClass('quicklink-btns-right') && quicklink_panel.hasClass('quicklink-anim-slide')) {

            quicklink_panel.stop().animate({'right': 0}, 300);

        }

    }, function () {

        if (quicklink_panel.hasClass('quicklink-btns-left') && quicklink_panel.hasClass('quicklink-anim-slide')) {

            quicklink_panel.animate({'left': '-' + (quicklink_panel_w - sbb_display_margin) + 'px'}, 300);

        } else if (quicklink_panel.hasClass('quicklink-btns-right') && quicklink_panel.hasClass('quicklink-anim-slide')) {

            quicklink_panel.animate({'right': '-' + (quicklink_panel_w - sbb_display_margin) + 'px'}, 300);

        }

    });
}

window.addEventListener('load', quickpanel); 
window.addEventListener('resize', quickpanel); 